import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {UserCardReviewRequest} from "../models/userCardReviewRequest";
import {Observable} from "rxjs";
import {UserCardReviewResponse} from "../models/userCardReviewResponse";
import {ReviewForAdminResponse} from '../interface/reviewForAdminResponse';

export interface Page<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserCardReviewService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  public create(request: UserCardReviewRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/user-card/reviews`, request);
  }

  public update(request: UserCardReviewRequest): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/user-card/reviews`, request);
  }

  public getReviewsByCardId(cardId: bigint): Observable<Array<UserCardReviewResponse>> {
    return this.http.get<Array<UserCardReviewResponse>>(`${this.apiUrl}/user-card/reviews/${cardId}`);
  }

  public getAverageRatingByCardId(cardId: bigint): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/user-card/reviews/rating/${cardId}`);
  }

  public deleteReviewById(reviewId: bigint): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/user-card/reviews/${reviewId}`);
  }

  public getAllReviews(page: number = 0, size: number = 10): Observable<Page<ReviewForAdminResponse>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', 'createdAt,DESC');
    return this.http.get<Page<ReviewForAdminResponse>>(`${this.apiUrl}/user-card/reviews`, { params });
  }

  public getCountOfReviews(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/user-card/reviews/count`);
  }
}
